<template>
  <div id="edit_contact">
    <div class="page-header header-filter"  data-parallax="true" style="background-image: url('/static/img/contact.jpg'); height:50vh; background-position:0px 44%">
      <div class="container">
        <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <div class="brand text-center">
                  <h1 class="title">(編輯)聯絡我們</h1>
                  <h3 class="title description">Contact us</h3>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div class="main">
        <div class="container">
          <div class="section">
            <!-- <span style="white-space:pre">
              {{ eng_addr }}
            </span> -->
            <div class="row">
              <table class="table table-bordered ">
                <tr>
                  <td class="table-secondary title" style="vertical-align: middle;">社交媒體</td>
                  <td>
                    <template v-for="(item, index) in media">
                      <div :key="index">
                        <img :src="item.img" style="width:10%">
                          <label class="btn btn-info">
                              <input type="file" class="custom-file-input" style="display: none;" id="img-upload" accept="image/*" @change="uploadImg($event, index)" />
                              <i class="fa fa-photo"></i> 上傳圖片
                          </label>
                      </div>                      
                    </template>
                  </td>
                </tr>
                <tr>
                  <td class="table-secondary title" style="vertical-align: middle;">地址</td>
                  <td>
                    <input type="text" class="form-control" v-model="cht_addr">
                    <br>
                    <textarea class="form-control" v-model="eng_addr" rows="5"></textarea>                    
                  </td>
                </tr>
                <tr>
                  <td class="table-secondary title" style="vertical-align: middle;">聯絡人</td>
                    <td><input type="text" class="form-control" v-model="cont_peo"></td>
                </tr>
                <tr>
                  <td class="table-secondary title" style="vertical-align: middle;">聯絡電話</td>
                    <td><input type="text" class="form-control" v-model="tele"></td>
                </tr>
                <tr>
                  <td class="table-secondary title" style="vertical-align: middle;">上班時間</td>
                    <td><input type="text" class="form-control" v-model="work_day"></td>
                </tr>
              </table>
              <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                  <span class="material-icons mr-2">save_alt</span> 儲存
              </button>
              <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                  <span class="material-icons mr-2">keyboard_return</span> 取消編輯
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_contact",
  props: [],
  data() {
    return {
      media: [],
      id:'',
      cht_addr: '',
      eng_addr: '',
      cont_peo: '',
      tele: '',
      work_day: '',
      imgFile: [],
      imgNumLimit: 4,
      imgString: [],
    };
  },
  methods: {
    getData: function(){
      var vm = this;
       axios
          .get(`/api/getcontact`)
          .then(res => {
            // console.log(res.data);
            var data = res.data.data[0];
            
            vm.id = data.id;
            vm.cht_addr = data.cht_addr;
            vm.eng_addr = data.eng_addr;
            vm.cont_peo = data.cont_peo;
            vm.tele = data.tele;
            vm.work_day = data.work_day;

            var img = data.img;
            if(img != null && img != '' && img != 'null'){
              var img_arr = img.split('@');
              var img_len = img.split('@').length;
              if(img_len > 1){
                for(var j = 0; j < img_len; j++){
                  vm.media.push({
                    img: img_arr[j]
                  })
                }
              }
              else{
                vm.media.push({
                  img: img
                })
              }
            }

          })
          .catch(err => {
            console.log(err);
          });
    },
    uploadImg: function(e, index) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.imgString = [];   //圖片資料清零
      _this.imgFile = [];     //圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {

              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              if (
                this.naturalWidth > this.naturalHeight &&
                this.naturalWidth > 800
              ) {
                expectWidth = 800;
                expectHeight =
                  (expectWidth * this.naturalHeight) / this.naturalWidth;
              } else if (
                this.naturalHeight > this.naturalWidth &&
                this.naturalHeight > 1200
              ) {
                expectHeight = 1200;
                expectWidth =
                  (expectHeight * this.naturalWidth) / this.naturalHeight;
              }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);


              var base64 = null;

              base64 = canvas.toDataURL("image/jpeg", 1);

              _this.imgString.push({ src: base64 });
              
             _this.media[index].img = _this.imgString[0].src;
              // console.log(JSON.stringify(_this.imgString));
            };
          };
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
    save_data: function(){
      var vm = this;
      var save_data = [];

      var pic_str = '';

      vm.media.forEach(function(item, idx){
          if (idx === vm.media.length - 1){ 
            pic_str += item.img;
          }
          else{
            pic_str += item.img + '@';
          }
      });

      save_data.push({
          id: vm.id,
          cht_addr: vm.cht_addr,
          eng_addr:  vm.eng_addr,
          cont_peo: vm.cont_peo,
          tele: vm.tele,
          work_day: vm.work_day,
          img: pic_str,
      });
      

      axios
        .post(`/api/savecontact`,save_data[0])
        .then(res => {
          // console.log(res);
          if(res.status == 200)
              vm.$router.push("/contact");
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancel_edit: function(){
      this.$router.push("/contact");
    },
  },
  filters: {},
  computed: {},
  created() {
    this.getData();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/contact/edit_contact.vue